import { setThemeMode, useThemeMode } from "@/hooks/theme"
import { ReactNode } from "react"

import * as Icons from '@/components/Icons'

function Button({ children, mode }: { children: ReactNode, mode: 'light' | 'dark' | 'system' }) {

  const themeMode = useThemeMode()

  return (
    <button
      className="h-10 flex-1 flex justify-center items-center rounded-md hover:bg-zinc-200 hover:dark:bg-zinc-800/80 data-[state=selected]:bg-zinc-200 dark:data-[state=selected]:bg-zinc-800/80"
      data-state={themeMode == mode ? 'selected' : 'default'}
      onClick={() => setThemeMode(mode)}
    >
      {children}
    </button>
  )

}

export function ThemeSelect({ }) {

  return (
    <div className='flex gap-2 p-2'>
      <Button mode="light">
        <Icons.Sun className="size-5" />
      </Button>
      <Button mode="dark">
        <Icons.Moon className="size-5" />
      </Button>
      <Button mode="system">
        <Icons.Desktop className="size-5" />
      </Button>
    </div>
  )

}